import { render, staticRenderFns } from "./jyzd.vue?vue&type=template&id=651c325b&scoped=true&"
import script from "./jyzd.vue?vue&type=script&lang=js&"
export * from "./jyzd.vue?vue&type=script&lang=js&"
import style0 from "./jyzd.vue?vue&type=style&index=0&id=651c325b&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651c325b",
  null
  
)

export default component.exports